/* eslint-disable */
import moment from "moment";
import {CSSProperties} from "react";


/**
 * 格式化成百分比
 * @param value
 */
export const formatToPercent = (value: string | number): string => {
	if (!value) {
		return '0%';
	}
	return Number(value)*100 + '%';
}


/**
 * 获取最近几个月
 * @param count
 */
export const getMonths = (count: number): string[] => {
	let months = [];
	let date = moment();
	for (let i = count - 1; i >= 0; i--) {
		months.push(date.clone().subtract(i, 'months').format('M月'));
	}

	return months;
}


/**
 * 获取样式
 */
export const getStyle = (data: any): {style?: CSSProperties} => {
	const { bg } = data || {};
	let style = {};
	if (bg) {
		style  = {style: {backgroundImage: `url(${require(`../assets/images/${bg}`)})`}};
	}
	return {...style};
}


/**
 * 生成className
 * @param classNames
 */
export const generateClassName = (classNames: string[]): string => {
	let classNameStr = classNames.filter((v: any) => v).join(' ');
	return classNameStr ? classNameStr : null;
}


/**
 * 判断变量类型
 * @param target
 * @param {objType} type
 * @returns {boolean}
 */
export const ObjTest = new class {

	private str: string = '';

	private getTargetStr(target) {
		this.str = Object.prototype.toString.call(target).toLowerCase();
	}

	// 对象
	isObj(target: any) {
		this.getTargetStr(target);
		return this.str === '[object object]';
	}
	// 函数
	isFunc(target: any) {
		this.getTargetStr(target);
		return this.str === '[object function]';
	}
	// 数组
	isArray(target: any) {
		this.getTargetStr(target);
		return this.str === '[object array]';
	}
	isNotEmptyArray(target: any) {
		this.getTargetStr(target);
		if (this.isArray(target) && target.length > 0) {
			return true;
		}
		return false;
	}
	// 字符串
	isStr(target: any) {
		this.getTargetStr(target);
		return this.str === '[object string]';
	}
	// 数字
	isNumber(target: any) {
		this.getTargetStr(target);
		return this.str === '[object number]';
	}
	// 未定义
	isUndefined(target: any) {
		this.getTargetStr(target);
		return this.str === '[object undefined]';
	}
	// 空指针
	isNull(target: any) {
		this.getTargetStr(target);
		return this.str === '[object null]';
	}
	// 无效数字
	isNan(target: any) {
		this.getTargetStr(target);
		return this.str === '[object number]' && isNaN(target);
	}
	// 有效json字符串
	isJSONStr(target: any) {
		if (this.isStr(target)) {
			try {
				let res = JSON.parse(target);
				if (this.isObj(res) || this.isArray(res)) {
					return true;
				}
				return false;
			}catch (e) {
				return false;
			}
		}
		return false;
	}
	// 判断是否空对象，不是Object类型的均返回true
	isEmptyObject(target: any) {
		if (this.isObj(target) && Object.keys(target).length > 0) {
			return false;
		}
		return true;
	}
}


/**
 * 获取url参数
 */
export function getQueryParams(): any {
    let params: any = {};
    const { href } = location;

    if (href.indexOf('?') === -1) {
        return params;
    }
    let search: string = href.split('?').slice(-1)[0];
    if (!search) {
        return params;
    }
    let temp: string[] = search.split('&');
    temp.forEach((v: string) => {
        if (!v) {
            return;
        }
        let index = v.indexOf('=');
        if (index > -1) {
            params[v.substring(0, index)] = decodeURIComponent(v.substring(index + 1));
        }
    })

    return params || {};
}




/**
 * 对get参数进行URI编码并输出query字符串
 */
export const encodeGetParams = (body: any) => {
	if (!body) {
		return '';
	}
	let newBody = {...body};
	let temp = [];
	for (let k in newBody) {
		if (newBody[k] === null || newBody[k] === undefined) {
			temp.push(`${k}=`);
		}else {
			temp.push(`${k}=${encodeURIComponent(newBody[k])}`);
		}
	}
	return `${temp.join('&')}`;
}


/**
 * 去掉html标签
 * @param value
 */
export function removeHTML(value: string) : string {
	if (!value) {
		return '';
	}
	return value.replace(/(<[^>]+>|&\w{4};|&.+;)/g, '');
}
